module.exports = __webpack_public_path__ + "img/blue_133.b3e6471a.png";